import { NostoSectionComponent } from '@theme/nosto-section-base';

/**
 * <ax-collection-list-nosto> — collection list personnalisée par Nosto.
 *
 * Le contenu vit dans des métaobjets Shopify (`nosto_collection_list` →
 * `nosto_collection_card`). Nosto Content Personalization ne renvoie QUE le handle
 * du métaobjet à afficher (par segment).
 *
 * Toute la mécanique (skeleton SSR → attente du handle → re-render SFR → morph, et
 * le découplage attente-Nosto / fetch) vit dans nosto-section-base.js. Ici on ne
 * surcharge que le sélecteur du handle propre à cette section.
 */
class AxCollectionListNostoComponent extends NostoSectionComponent {
  static elementName = 'ax-collection-list-nosto';

  // Nosto a une latence variable sur ce placement (pics >5s constatés). Plutôt que de
  // bloquer sur le skeleton, on rend vite les blocks par défaut (timeout court côté
  // settings) puis on upgrade en perso dès que le handle tardif tombe.
  static lateUpgrade = true;

  get handleSelector() {
    return '[data-nosto-collection-list-handle], [data-handle]';
  }
}

if (!customElements.get('ax-collection-list-nosto')) {
  customElements.define('ax-collection-list-nosto', AxCollectionListNostoComponent);
}
